module.exports = __webpack_public_path__ + "img/bell-icon.b8678c8f.svg";